export default function createReducer<S>(getInitialState, handlers) {
  return (state: S = getInitialState(), action = { type: '' }) => {
    if (!action || !handlers[action.type]) {
      return state;
    }

    const result = handlers[action.type](state, action);

    if (result === state) {
      return state;
    }

    return { ...state, ...result };
  };
}
